import React from "react";
import '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faReact, faDocker, faPython } from '@fortawesome/free-brands-svg-icons';
import Chip from '@mui/material/Chip';
import { useLanguage } from '../i18n/LanguageProvider';
import '../assets/styles/Expertise.scss';

const icons = [faReact, faDocker, faPython];

function Expertise() {
    const { t } = useLanguage();
    const cards = t('skills.cards') as { title: string; description: string; techLabel: string; tags: string[] }[];

    return (
    <div className="container" id="expertise">
        <div className="skills-container">
            <h1>{t('skills.title')}</h1>
            <div className="skills-grid">
                {cards.map((card, index) => (
                    <div className="skill" key={card.title}>
                        <FontAwesomeIcon icon={icons[index % icons.length]} size="3x"/>
                        <h3>{card.title}</h3>
                        <p>{card.description}</p>
                        <div className="flex-chips">
                            <span className="chip-title">{card.techLabel}:</span>
                            {card.tags.map((label) => (
                                <Chip key={label} className='chip' label={label} />
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    </div>
    );
}

export default Expertise;